module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "messageListSettingContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "backgroundBoard"
    },
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "messageListSettingMenu"
    }
  }, [_c('div', {
    attrs: {
      "id": "menuCloseButton"
    },
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), _vm._l((_vm.menuItem), function(menu, index) {
    return _c('div', {
      key: index,
      staticClass: "settingMenu"
    }, [_c('div', {
      staticClass: "settingMenuTitle"
    }, [_vm._v(_vm._s(menu.menuTitle))]), _vm._v(" "), _c('form', _vm._l((menu.items), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "settingMenuItem"
      }, [_c('span', {
        staticClass: "settingMenuItemValue"
      }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _vm._l((item.values), function(value, index) {
        return _c('div', {
          key: index
        }, [_c('input', {
          staticClass: "settingMenuItemValue",
          attrs: {
            "type": "radio",
            "name": item.valueName
          },
          domProps: {
            "value": value.value,
            "checked": value.selected
          },
          on: {
            "click": item.changeMethod
          }
        }), _vm._v(" "), _c('label', [_vm._v(_vm._s(value.name))])])
      })], 2)
    }), 0)])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d03129e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-message-setting-menu.vue
// module id = 105
// module chunks = 0